"use strict";

const ROLES_OF_USER = "ROLES_OF_USER";
const ADMIN_ROLE = "role::admin";

const INST_GROUPS_FOR_MAPPING_REQUEST = "INST_GROUPS_FOR_MAPPING_REQUEST";
const INST_GROUPS_FOR_MAPPING_SUCCESS = "INST_GROUPS_FOR_MAPPING_SUCCESS";
const INST_GROUPS_FOR_MAPPING_ERROR = "INST_GROUPS_FOR_MAPPING_ERROR";

const USER_GROUPS_FOR_MAPPING_REQUEST = "USER_GROUPS_FOR_MAPPING_REQUEST";
const USER_GROUPS_FOR_MAPPING_SUCCESS = "USER_GROUPS_FOR_MAPPING_SUCCESS";
const USER_GROUPS_FOR_MAPPING_ERROR = "USER_GROUPS_FOR_MAPPING_ERROR";

const GENERIC_ERROR_MESSAGE =
  "Failed - Due to Technical error, Please try again";

  const MAX_INSTRUMENT_UNENROLLMENT_COUNT_REQUEST = "MAX_INSTRUMENT_UNENROLLMENT_COUNT_REQUEST";
const MAX_INSTRUMENT_UNENROLLMENT_COUNT_SUCCESS = "MAX_INSTRUMENT_UNENROLLMENT_COUNT_SUCCESS";
const MAX_INSTRUMENT_UNENROLLMENT_COUNT_ERROR = "MAX_INSTRUMENT_UNENROLLMENT_COUNT_ERROR";

export {
  ROLES_OF_USER,
  ADMIN_ROLE,
  INST_GROUPS_FOR_MAPPING_ERROR,
  INST_GROUPS_FOR_MAPPING_REQUEST,
  INST_GROUPS_FOR_MAPPING_SUCCESS,
  USER_GROUPS_FOR_MAPPING_ERROR,
  USER_GROUPS_FOR_MAPPING_REQUEST,
  USER_GROUPS_FOR_MAPPING_SUCCESS,
  GENERIC_ERROR_MESSAGE,
  MAX_INSTRUMENT_UNENROLLMENT_COUNT_REQUEST,
  MAX_INSTRUMENT_UNENROLLMENT_COUNT_SUCCESS,
  MAX_INSTRUMENT_UNENROLLMENT_COUNT_ERROR,
};
